
import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

// Lazy load components
const HomePage = lazy(() => import('../pages/home/page'));
const TentangPage = lazy(() => import('../pages/tentang/page'));
const ProgramPage = lazy(() => import('../pages/program/page'));
const ProgramIndikatorPage = lazy(() => import('../pages/program/indikator/page'));
const ProgramProyekRehabilitasiPage = lazy(() => import('../pages/program/proyek-rehabilitasi/page'));
const LaporanPage = lazy(() => import('../pages/laporan/page'));
const PeraturanPage = lazy(() => import('../pages/peraturan/page'));
const PetaMangrovePage = lazy(() => import('../pages/peta-mangrove/page'));
const DownloadPage = lazy(() => import('../pages/download/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

// Direct imports for indikator pages
import SosialisasiPage from '../pages/indikator/sosialisasi/page';
import PadiatapaPage from '../pages/indikator/padiatapa/page';
import SekolahLapangPage from '../pages/indikator/sekolah-lapang/page';
import RehabMangrovePage from '../pages/indikator/rehab-mangrove/page';
import MonevPage from '../pages/indikator/monev/page';
import HibahUsahaPage from '../pages/indikator/hibah-usaha/page';

// Layanan pages
const PengaduanPage = lazy(() => import('../pages/layanan/pengaduan/page'));
const KatalogProdukPage = lazy(() => import('../pages/layanan/katalog-produk/page'));
const MonitoringPage = lazy(() => import('../pages/layanan/monitoring/page'));

// Publikasi pages
const SiaranPersPage = lazy(() => import('../pages/publikasi/siaran-pers/page'));

// Kisah pages
const NelayanEkowisataStory = lazy(() => import('../pages/kisah/nelayan-ekowisata/page'));
const PemulihanEkosistemStory = lazy(() => import('../pages/kisah/pemulihan-ekosistem/page'));

// Story pages
const CommunityTransformationStory = lazy(() => import('../pages/stories/community-transformation/page'));
const FieldReportStory = lazy(() => import('../pages/stories/field-report/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/tentang',
    element: <TentangPage />
  },
  {
    path: '/program',
    element: <ProgramPage />
  },
  {
    path: '/program/indikator',
    element: <ProgramIndikatorPage />
  },
  {
    path: '/program/proyek-rehabilitasi',
    element: <ProgramProyekRehabilitasiPage />
  },
  {
    path: '/laporan',
    element: <LaporanPage />
  },
  {
    path: '/peraturan',
    element: <PeraturanPage />
  },
  {
    path: '/peta-mangrove',
    element: <PetaMangrovePage />
  },
  {
    path: '/download',
    element: <DownloadPage />
  },
  {
    path: '/indikator/sosialisasi',
    element: <SosialisasiPage />
  },
  {
    path: '/indikator/padiatapa',
    element: <PadiatapaPage />
  },
  // New indikator routes
  {
    path: '/indikator/sekolah-lapang',
    element: <SekolahLapangPage />
  },
  {
    path: '/indikator/rehab-mangrove',
    element: <RehabMangrovePage />
  },
  {
    path: '/indikator/monev',
    element: <MonevPage />
  },
  {
    path: '/indikator/hibah-usaha',
    element: <HibahUsahaPage />
  },
  // Layanan routes
  {
    path: '/layanan/pengaduan',
    element: <PengaduanPage />
  },
  {
    path: '/layanan/katalog-produk',
    element: <KatalogProdukPage />
  },
  {
    path: '/layanan/monitoring',
    element: <MonitoringPage />
  },
  // Publikasi routes
  {
    path: '/publikasi/siaran-pers',
    element: <SiaranPersPage />
  },
  {
    path: '/kisah/nelayan-ekowisata',
    element: <NelayanEkowisataStory />
  },
  {
    path: '/kisah/pemulihan-ekosistem',
    element: <PemulihanEkosistemStory />
  },
  {
    path: '/stories/community-transformation',
    element: <CommunityTransformationStory />
  },
  {
    path: '/stories/field-report',
    element: <FieldReportStory />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;
